export default __webpack_public_path__ + "src/images/packages/cradle-boutique-hotel/f731e27a04cef68496214c4d5ba6c678-1.png";